/* eslint-disable */
export default {
  dialPlaceholder: 'Saisir un nom ou numéro',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
